import { object, string, array, bool, date, mixed } from 'yup';

import { TaskPriority, TaskStatus } from '@graphql/generated';
import { taskInviteEmailSchema } from '@schemas/taskInviteEmailSchema';
import { userSchema } from '@schemas/userSchema';

export const PROJECT_REQUIRED_ERROR = 'Project is required';
const createTaskFormSchema = object({
  name: string().required('Name is a required field'),
  description: string().nullable(),
  projectId: string().required(PROJECT_REQUIRED_ERROR),
  projectUUId: string().nullable(),
  users: array().of(userSchema).ensure(),
  inviteEmails: array().of(taskInviteEmailSchema).nullable(),
  skillIds: array().of(string()).ensure(),
  phaseId: string().nullable(),
  // NOTE: oneOf was not respecting undefined and null values though documentation suggests undefined
  // will not fail the validator.
  priority: mixed()
    .oneOf([undefined, ...Object.values(TaskPriority)])
    .required(),
  status: mixed().oneOf([null, undefined, ...Object.values(TaskStatus)]),
  frequency: string(),
  recurring: bool(),
  fixedOrder: bool(),
  dependencyIds: array().of(string()).ensure(),
  startDate: date().nullable(),
  dueDate: date()
    .when('startDate', (startDate, schema) =>
      startDate
        ? schema.min(startDate, 'Due date cannot be before start time')
        : schema
    )
    .nullable(),
  completedAt: date().nullable(),
  files: array().nullable(),
  isOnboardingTask: bool().default(false),
});

export default createTaskFormSchema;
